import {
  ConfirmedResellerIcon,
  InfluencerIcon,
  IntermediateResellerIcon,
  BeginnerReseller
} from "assets/icons";

import { ResellerLevel } from "../constants";

export const getResellerLevelLabelIcon = (level: ResellerLevel) => {
  switch (level) {
    case ResellerLevel.Buyer:
    case ResellerLevel.IncompleteReseller:
      return null;
    case ResellerLevel.BeginnerReseller:
      return BeginnerReseller;
    case ResellerLevel.IntermediateReseller:
      return IntermediateResellerIcon;
    case ResellerLevel.ConfirmedReseller:
      return ConfirmedResellerIcon;
    case ResellerLevel.Influencer:
      return InfluencerIcon;
    default:
      return null;
  }
};
